module.exports = __webpack_public_path__ + "static/media/img5_1.0980c210.png";